import rmAxiosInstance from "./RichMediaAxiosInstace";


const postRichMediaResponse = (body) => {
  return rmAxiosInstance.post(
    "/rich_media/add-rich-media-response",
    body
  );
};

export default {
  postRichMediaResponse,
};
